var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "form-group" }),
      _vm._v(" "),
      _vm.roleRules.DISCIPLINE_FLG === "Y"
        ? [
            _vm._l(_vm.schools, function(school, idx) {
              return _c("section", { key: "school-" + idx }, [
                school.length > 0
                  ? _c("h2", [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(school[0].SCHOOL_TITLE) +
                          "\n\t\t\t"
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                school.length > 0
                  ? _c(
                      "div",
                      { staticClass: "table-responsive" },
                      [
                        _c(
                          "table-editable-list",
                          {
                            attrs: {
                              columns: _vm.columns,
                              "show-select": false,
                              "show-actions": false
                            }
                          },
                          [
                            _c(
                              "template",
                              { slot: "data-row" },
                              [
                                _vm._l(school, function(incident, index) {
                                  return [
                                    _c(
                                      "table-list-row",
                                      {
                                        key: "Incident_" + idx + "_" + index,
                                        attrs: {
                                          columns: _vm.columns,
                                          rowdata: incident,
                                          rowIndex: index,
                                          showActions: false
                                        }
                                      },
                                      [
                                        _c(
                                          "template",
                                          { slot: "infractions" },
                                          [
                                            _c(
                                              "ul",
                                              [
                                                _vm._l(
                                                  incident.INFRACTIONS,
                                                  function(infraction, j) {
                                                    return [
                                                      infraction.length
                                                        ? _c("li", { key: j }, [
                                                            _vm._v(
                                                              _vm._s(infraction)
                                                            )
                                                          ])
                                                        : _vm._e()
                                                    ]
                                                  }
                                                )
                                              ],
                                              2
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "template",
                                          { slot: "actionsTaken" },
                                          [
                                            _c(
                                              "ul",
                                              [
                                                _vm._l(
                                                  incident.ACTIONS,
                                                  function(action, j) {
                                                    return [
                                                      action.length
                                                        ? _c("li", { key: j }, [
                                                            _vm._v(
                                                              _vm._s(action)
                                                            )
                                                          ])
                                                        : _vm._e()
                                                    ]
                                                  }
                                                )
                                              ],
                                              2
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        !!incident.INCIDENT_DESC
                                          ? _c(
                                              "template",
                                              { slot: "description" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "text-center"
                                                  },
                                                  [
                                                    incident.INCIDENT_DESC
                                                      .length
                                                      ? _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "btn btn-default",
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.openDescriptionModal(
                                                                  incident
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "MAIN_CONTENT.Discipline.showDescription"
                                                                  )
                                                                ) +
                                                                "\n\t\t\t\t\t\t\t\t\t\t"
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ],
                                      2
                                    )
                                  ]
                                })
                              ],
                              2
                            )
                          ],
                          2
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                school.length === 0
                  ? _c("div", { staticClass: "alert alert-info" }, [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(
                            _vm.$t("MAIN_CONTENT.Discipline.noIncidents")
                          ) +
                          "\n\t\t\t"
                      )
                    ])
                  : _vm._e()
              ])
            }),
            _vm._v(" "),
            Object.keys(_vm.schools).length === 0
              ? _c("div", { staticClass: "alert alert-info" }, [
                  _vm._v(
                    "\n\t\t\t" +
                      _vm._s(_vm.$t("MAIN_CONTENT.Discipline.noIncidents")) +
                      "\n\t\t"
                  )
                ])
              : _vm._e()
          ]
        : [
            _vm._v(
              "\n\t\t" +
                _vm._s(
                  _vm.$t("MAIN_CONTENT.commonContent.invalidPermissions")
                ) +
                "\n\t"
            )
          ],
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            "modal-title": _vm.$t(
              "MAIN_CONTENT.Discipline.incidentModalTitle",
              { description: _vm.selectedIncident.DATE_TIME }
            ),
            show: _vm.showDescriptionModal,
            "dialog-size": "lg",
            name: "incidentDescription",
            fields: ""
          },
          on: {
            close: function($event) {
              return _vm.closeDescriptionModal()
            }
          }
        },
        [
          _c("div", {
            domProps: { innerHTML: _vm._s(_vm.selectedIncident.INCIDENT_DESC) }
          }),
          _vm._v(" "),
          _c(
            "template",
            { attrs: { close: _vm.closeDescriptionModal }, slot: "footer" },
            [
              _c(
                "button",
                {
                  staticClass: "btn btn-default",
                  attrs: { type: "button" },
                  on: { click: _vm.closeDescriptionModal }
                },
                [
                  _vm._v(
                    "\n\t\t\t\t" +
                      _vm._s(_vm.$t("MAIN_CONTENT.commonContent.closeButton")) +
                      "\n\t\t\t"
                  )
                ]
              )
            ]
          )
        ],
        2
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }